module.exports = __webpack_public_path__ + "img/facebook.a09b2f44.svg";